import { render, staticRenderFns } from "./search-saved-messages-dialog.vue?vue&type=template&id=d561a7c4&scoped=true&"
import script from "./search-saved-messages-dialog.vue?vue&type=script&lang=js&"
export * from "./search-saved-messages-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d561a7c4",
  null
  
)

export default component.exports